import { useEffect } from 'react'
import { useSearchParams } from 'react-router'

import { EMPTY_LIST } from '../../../../constants/common'
import { SUBMENU_PARAM_KEY } from '../../../../constants/route'
import { useSubMenuActions, useVariableRef } from '../../../../hooks'
import { identity } from '../../../../utils/common'
import { getSubMenuDefaultItemName } from '../../../SubMenu'

import { isAsyncTableSubOutOfSubMenu } from './useAsyncTableSubMenu.utils'

export function useAsyncTableSubMenu({
  handleSetSubMenu,
  shouldCheckSub,
  sub,
  transformSubMenu = identity,
  withoutSubMenu,
}) {
  const [, setSearchParams] = useSearchParams()

  const { cleanSubMenu, setSecondaryMenu } = useSubMenuActions()

  const subRef = useVariableRef(sub)

  const setTableSubMenu =
    handleSetSubMenu ?? (withoutSubMenu ? null : setSecondaryMenu)

  const isSubChecked = shouldCheckSub ?? !withoutSubMenu

  function handleSetTableSubMenu(subMenu) {
    setTableSubMenu(transformSubMenu(subMenu))
  }

  function replaceSub(nextSub) {
    setSearchParams(
      prev => {
        const next = new URLSearchParams(prev)

        next.set(SUBMENU_PARAM_KEY, nextSub)

        return next
      },
      { replace: true }
    )
  }

  function handleCheckSub(config) {
    const subMenu = transformSubMenu(config?.sub_menu ?? EMPTY_LIST)

    const isSubInvalid =
      isSubChecked && isAsyncTableSubOutOfSubMenu({ sub, subMenu })

    const shouldReplaceSub =
      isSubInvalid && !withoutSubMenu && subRef.current === sub

    if (shouldReplaceSub) {
      replaceSub(getSubMenuDefaultItemName(subMenu))
    }

    return !isSubInvalid
  }

  useEffect(() => {
    if (!withoutSubMenu) {
      return function cleanup() {
        cleanSubMenu()
      }
    }
  }, [withoutSubMenu])

  return {
    handleCheckSub,
    handleSetSubMenu: setTableSubMenu ? handleSetTableSubMenu : null,
  }
}
